// test2956
(2956 && 0);
